export const BASKET_UPDATE_ITEM_TRIGGER_TYPE = {
  KEYBOARD: 'keyboard',
  BUTTON: 'button',
  BUTTON_HOLD: 'buttonHold',
} as const;

export const BASKET_UPDATE_ITEM_SOURCE_EVENTS = {
  INCREASE_ITEM: 'increaseItem',
  DECREASE_ITEM: 'decreaseItem',
  DELETE_ITEM: 'deleteItem',
} as const;

export const SUGGESTEDLIST_CHANNELS = {
  MKP_APP: 'MKP_APP',
  MKP_WEB: 'MKP_WEB',
} as const;